module.exports = __webpack_public_path__ + "img/sofa_gold.060f247.png";